import { hexToRGB } from '@repo-level/core-front';
import panelBg from 'assets/images/headlinePromo/revel-panel-bg.webp';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScHeadlinePromoPanel = styled.div`
  display: flex;
  height: 80px;
  padding: 0 12px;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
  background: url(${panelBg}) center / cover no-repeat,
    ${({ theme }) => theme.grayColor6};

  .inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    width: 100%;
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 0 6px;
    height: 32px;
  }

  .artifact {
    flex-shrink: 0;
    object-fit: contain;
  }

  .title {
    color: ${({ theme }) => theme.whiteColor};
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0;
    white-space: nowrap;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    .teaser {
      color: ${({ theme }) => theme.whiteColor};
      text-align: center;
      font-size: 10px;
      font-weight: 700;
      line-height: 14px;
      letter-spacing: 0;
    }
  }

  .value-wrapper {
    .progress-value .label {
      display: none;
    }

    .progress-value,
    .reward-value {
      color: ${({ theme }) => theme.whiteColor};
      text-align: center;
      font-size: 12px;
      font-weight: 700;
      line-height: 18px;
      letter-spacing: 0;
      text-align: center;
    }
  }

  @media (${device.mobile}) {
    padding: 12px;
    border-radius: 16px;

    .inner {
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }

    .row {
      padding: 0;
    }

    .title {
      display: none;
    }

    .content {
      .teaser {
        text-align: left;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0;
      }
    }

    .value-wrapper {
      .progress-value,
      .reward-value {
        text-align: left;
        font-size: 14px;
        line-height: 20px;
      }

      .progress-value .label,
      .reward-value .label {
        display: inline;
      }
    }

    svg {
      margin-left: auto;

      path {
        fill: ${({ theme }) => hexToRGB(theme.whiteColor, 0.4)};
      }
    }
  }
`;
